namespace SP {
    export enum ReturnActionType {
        Refund = 1,
        Exchange = 2,
        Other = 3,
    }
}
